import React from 'react';

const TableColumn = ({ children }) => {
  return <td>{children}</td>;
};

export default TableColumn;
